import FontIcon from '@/shared/ui/FontIcon';

type CloseToastProps = {
  closeToast: () => void;
};

export default function CloseToast({ closeToast }: CloseToastProps) {
  return (
    <button type="button" className="action-close-toast" onClick={closeToast} aria-label="Dismiss">
      <FontIcon icon="close" className="close-toast" />
    </button>
  );
}
